import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionStaffFunction } from './competition-staff-function'
import { CompetitionStaffFunctionSerializer } from './competition-staff-function.serializer'

@Injectable()
export class CompetitionStaffFunctionService extends ResourceService<CompetitionStaffFunction> {
  constructor(
    private http: HttpClient,
    private competitionStaffFunctionSerializer: CompetitionStaffFunctionSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-staff-functions`,
      competitionStaffFunctionSerializer
    )
  }
}
